import { useLocation } from "react-router-dom";
import Footer from "./Footer";

// Single global footer (Phase 24): every public page + dashboards; the admin shell has its own full-height layout.
export default function SiteFooter() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") && pathname !== "/admin/login") return null;
  const compact = pathname.startsWith("/provenance/dashboard") || pathname.startsWith("/souq/dashboard");
  return <div className={compact ? "site-footer-compact" : ""}><Footer /></div>;
}
